import React, { Component } from "react";
import "./css/greivance.css";
import FormOne from "./FormOne";
import { PostData } from "./../../api/service";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

export default class Grievance extends Component {
  onSubmit(data) {
    PostData("/addgrievance", data).then((resp) => {
      confirmAlert({
        title: "Sucessfully Submitted",
        message: "You will receive notifications thought email",
        buttons: [
          {
            label: "Okay",
            onClick: () => window.location.reload(),
          },
        ],
      });
    });
  }
  render() {
    return (
      <div className="container">
        <div className="reg-form">
          <div className="top-bar"></div>
          <div className="form-contents">
            <h3
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img src={`/logo.jpeg`} style={{ width: 100 }} />{" "}
              <div style={{ marginLeft: 10, fontWeight: 700 }}>
                Grievance Submission System
                <br />
                <div style={{fontSize: 16}}>Rangia College</div>
              </div>
            </h3>
            <hr />
            <h6>
              ** Please enter valid phone number. Any updates will be notified
              through your phone number.
            </h6>
            <hr />
            <FormOne onSubmit={this.onSubmit.bind(this)} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Grievance/Grievance.js